import { getResData } from "utils/helpers";
import request from "utils/request";
import {
  URL_APP_VERSION_ADD,
  URL_APP_VERSION_DELETE,
  URL_APP_VERSION_LIST,
  URL_APP_VERSION_UPDATE,
} from "../../constants";

export const fetchAppVersionList = async (data) => {
  try {
    const res = await request.post(URL_APP_VERSION_LIST, data);
    return getResData(res.data);
  } catch (error) {
    if (error.response.message === "Restricted access") {
      request.deleteAuthorizationToken();
      window.location.pathname = `${process.env.PUBLIC_URL}/admin`;
      return error.response.message
    }
    console.error("fetchAppVersionList error => ", error);
    console.log("Error Response fetchAppVersionList => ", error.response);
    return null;
  }
};

export const addAppVersion = async (data) => {
  try {
    const res = await request.post(URL_APP_VERSION_ADD, data);
    return getResData(res.data);
  } catch (error) {
    if (error.response.message === "Restricted access") {
      request.deleteAuthorizationToken();
      window.location.pathname = `${process.env.PUBLIC_URL}/admin`;
      return error.response.message
    }
    console.error("addAppVersionList error => ", error);
    console.log("Error Response addAppVersionList => ", error.response);
    return null;
  }
};

export const updateAppVersion = async (data) => {
  try {
    const res = await request.post(URL_APP_VERSION_UPDATE, data);
    return getResData(res.data);
  } catch (error) {
    if (error.response.message === "Restricted access") {
      request.deleteAuthorizationToken();
      window.location.pathname = `${process.env.PUBLIC_URL}/admin`;
      return error.response.message
    }
    console.error("updateAppVersionList error => ", error);
    console.log("Error Response updateAppVersionList => ", error.response);
    return null;
  }
};

export const deleteAppVersion = async (data) => {
  try {
    const res = await request.post(URL_APP_VERSION_DELETE, data);
    return getResData(res.data);
  } catch (error) {
    if (error.response.message === "Restricted access") {
      request.deleteAuthorizationToken();
      window.location.pathname = `${process.env.PUBLIC_URL}/admin`;
      return error.response.message
    }
    console.error("deleteVersionList error => ", error);
    console.log("Error Response deleteVersionList => ", error.response);
    return null;
  }
};